module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-V2.4352f3ae.jpg";